<template>
  <div class="updatedlynxapi-list">

    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-update</v-icon>{{$t('updatedlynxapi.updatedlynxapis')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
          </div>
        </v-toolbar>

          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <UpdatedLynxapiFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.start" slot-scope="{ item }">
            {{ formatDateTime(item['start'], 'long') }}
          </template>
          <template slot="item.end" slot-scope="{ item }">
            {{ formatDateTime(item['end'], 'long') }}
          </template>
          </v-data-table>

      </v-sheet>
    </v-container>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import UpdatedLynxapiFilterForm from '../../components/updatedlynxapi/Filter';
import DataFilter from '../../components/DataFilter';

export default {
  name: 'UpdatedLynxapiList',
  servicePrefix: 'UpdatedLynxapi',
  mixins: [ListMixin],
  components: {

    UpdatedLynxapiFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('updatedlynxapi.start'), value: 'start' },
        { text: this.$t('updatedlynxapi.end'), value: 'end' },
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('updatedlynxapi', {
      items: 'list'
    }),
    ...mapFields('updatedlynxapi', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('updatedlynxapi', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
